import { render, staticRenderFns } from "./Second_mobile.vue?vue&type=template&id=0e90275d&scoped=true&"
import script from "./Second_mobile.vue?vue&type=script&lang=js&"
export * from "./Second_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Second_mobile.vue?vue&type=style&index=0&id=0e90275d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90275d",
  null
  
)

export default component.exports